import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ComponentRef, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { LegExplo } from '../volkswagen.types';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-xml-legend',
  imports: [TranslocoPipe, CommonModule],
  standalone: true,
  template: `
    <div class="w-full pb-4 max-lg:min-w-[calc(100dvw-2rem)] lg:w-[26dvw]">
      <div class="h-full w-full rounded-lg border border-gray-200 bg-gray-50 p-4">
        <h4 class="mb-3 text-sm font-semibold text-gray-800">{{ 'documents.vw.labels.legend' | transloco }}</h4>

        @if (data.children && data.children.length > 0) {
          <ol class="ml-4 list-decimal space-y-4 text-sm">
            <ng-template #childrenContainer></ng-template>
          </ol>
        }

        <!-- <div class="bg-slate-50 text-xs">{{ data | json }}</div> -->
      </div>
    </div>
  `,
})
export class LegendComponent extends XMLElementBaseComponent<LegExplo> implements AfterViewInit, OnDestroy {
  @ViewChild('childrenContainer', { read: ViewContainerRef })
  childrenContainer!: ViewContainerRef;

  private childComponents: ComponentRef<XMLElementBaseComponent>[] = [];

  ngAfterViewInit() {
    if (this.data?.children) {
      this.childRenderService.setProvider(this.provider);
      this.childComponents = this.childRenderService.renderChildren(this.data.children, this.childrenContainer);
    }
  }

  ngOnDestroy() {
    this.childComponents.forEach((ref) => ref.destroy());
  }
}
